export const brandingKeys = {
    uploadLogo: (fileName?: string) => ['branding', 'uploadLogo', fileName] as const,
    updateConfig: ['branding', 'updateConfig'] as const,
} as const
